// External library import
import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const PQDownloadValidation = (type) =>
    yup.object().shape({
        market: yup.string().test('market', ERRORS.required, (value, c) => {
            if (type === 'PQDownload') {
                if (c.parent.capacity && !value) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (!value) {
                    return false;
                } else {
                    return true;
                }
            }
        }),
        capacity: yup.string().test('capacity', ERRORS.required, (value, c) => {
            if (type === 'PQDownload') {
                if (c.parent.market && !value) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }),
    });
